module.exports = __webpack_public_path__ + "img/xiao.07895bd7.png";